import { Grid } from "@mui/material";
import React from "react";

import AnalyticsWidgetSummary from "./AnalyticsWidgetSummary";
import { HOST_API } from "../../config";

export default function Dashboard() {

  const [data, setData] = React.useState(null);

  const getCount = async () => {
    try {
      const data = await fetch(HOST_API + "getCount");
      const  courseData = await fetch(HOST_API + "coursesStatics");
      const result = await data.json();
      const courseDataResult = await courseData.json();
      const mergedata=Object.assign(courseDataResult,result)
      setData(mergedata);
    } catch (error) {
      console.log("error");
    }
  };
  React.useEffect(() => {
    getCount();
  }, []);
  console.log(data)
  return (
    <div>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6} md={3}>
          <AnalyticsWidgetSummary
            title="Total Gallery Images"
            total={data?.totalGallery 
            || 0}
            icon={"ant-design:android-filled"}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <AnalyticsWidgetSummary
            title="News & Events"
            total={data?.totalBlog || 0}
            color="info"
            icon={"ant-design:apple-filled"}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <AnalyticsWidgetSummary
            title="Contact Us lead"
            total={data?.contactLead ||0}
            color="warning"
            icon={"ant-design:windows-filled"}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <AnalyticsWidgetSummary
            title="All Courses Lead"
            total={data?.courseslead ||0}
            color="error"
            icon={"ant-design:bug-filled"}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <AnalyticsWidgetSummary
            title="English in UK"
            total={data?.english_uk ||0}
            
            icon={"ant-design:bug-filled"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <AnalyticsWidgetSummary
            title="English in USA"
            total={data?.english_usa ||0}
            color="info"
            icon={"ant-design:bug-filled"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <AnalyticsWidgetSummary
            title="Foundation in UK"
            total={data?.foundation_uk ||0}
            color="warning"
            icon={"ant-design:bug-filled"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <AnalyticsWidgetSummary
            title="Foundation in USA"
            total={data?.foundation_usa ||0}
            color="error"
            icon={"ant-design:bug-filled"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <AnalyticsWidgetSummary
            title="Undergraduate in UK"
            total={data?.undergraduate_uk ||0}
           
            icon={"ant-design:bug-filled"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <AnalyticsWidgetSummary
            title="Undergraduate in USA"
            total={data?.undergraduate_usa ||0}
            color="info"
            icon={"ant-design:bug-filled"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <AnalyticsWidgetSummary
            title="Master in UK"
            total={data?.master_uk ||0}
            color="warning"
            icon={"ant-design:bug-filled"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <AnalyticsWidgetSummary
            title="Master in USA"
            total={data?.master_usa ||0}
            color="error"
            icon={"ant-design:bug-filled"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <AnalyticsWidgetSummary
            title="PHD"
            total={data?.phd ||0}
            
            icon={"ant-design:bug-filled"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <AnalyticsWidgetSummary
            title="Clinical Pharmacy"
            total={data?.clinical_pharmacy ||0}
            color="info"
            icon={"ant-design:bug-filled"}
          />
        </Grid>

      </Grid>
    </div>
  );
}
